export default {"src":"/_next/static/media/jobs-icon.7ddfe796.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};